import React from 'react';
import { Link } from 'react-router-dom';
import {TEACHER_PAGE_PATH,
  ADMINISTRATORS_PAGE_PATH,
  HOW_TO_VIDEOS_PAGE_PATH,
  TEACHER_SUPPORT_PAGE_PATH
} from '../../../routes/route-paths';

import styled, { css } from 'styled-components';
import { white, indigo, deepCoveDark, royal, whiteLilac, mischka } from '../shared-styles/Colors';
import { trackToGtmFE } from '../../../utils/gtm-event-common';

const MenuWrapper = styled.ul`
  position: absolute;
  top: 100%;
  left: -2.0rem;
  display: none;
  z-index: 1;
  ${(props) =>
    props.theme.white
      ? css`
          border: solid 0.1rem ${mischka};
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
        `
      : ''};
`;


const EduLink = styled.li`
  cursor: pointer;
  border-bottom: solid 0.1rem ${whiteLilac};
  text-align: left;
  & > a {
    background-color: ${(props) => (props.theme.white ? white : deepCoveDark)};;
    color: ${(props) => (props.theme.white ? deepCoveDark : white)};
    padding: 1rem 2.2rem;
    display: inline-block;
    width: 20.0rem;
    & :hover {
      background-color: ${(props) => (props.theme.white ? whiteLilac : royal)};
      text-decoration: none;
      color: ${(props) => (props.theme.white ? indigo : white)};
    }
  }
  @media screen and (max-width:1279px){
    padding-bottom:1.6rem;
    &:first-child{
       padding-top:1.3rem;
     }
  }
`;

const windowReload = () => {
  setTimeout(function(){
    window.location.reload();
  },10);
};

const onDropdownLinkClick = (e,name,pathname) => {
  e.stopPropagation();
  trackToGtmFE('clicked_navigation',{'Click Text': name,'Click URL':pathname})          
  typeof trackEventOnGA != "undefined" && trackEventOnGA(`${name}`, 'Clicked', 'from: Global Header' );
}

const EducatorMenu = React.memo(() => {
  return (

    <MenuWrapper className={`header-curriculum-menu-wrapper header-curriculum-menu-wrapper-white-theme`}>
      <EduLink className="edu-link">
        <Link to={{ pathname: TEACHER_PAGE_PATH}} className="edu-link-a" onClick={(e) => {onDropdownLinkClick(e,"Teacher", TEACHER_PAGE_PATH); windowReload()}} >
          Teacher
        </Link>
      </EduLink>
      <EduLink className="edu-link">
        <Link to={{ pathname: ADMINISTRATORS_PAGE_PATH}} onClick={(e) => {onDropdownLinkClick(e,"Administrator", ADMINISTRATORS_PAGE_PATH); windowReload()}} className="edu-link-a">
          Administrator
        </Link>
      </EduLink>
      <EduLink className="edu-link">
        <Link to={{ pathname: HOW_TO_VIDEOS_PAGE_PATH }} onClick={(e) => {onDropdownLinkClick(e,"Teacher How To's", HOW_TO_VIDEOS_PAGE_PATH); windowReload()}} className="edu-link-a">
          Teacher How To's
        </Link>
      </EduLink>
      <EduLink className="edu-link">
        <Link to={{ pathname: TEACHER_SUPPORT_PAGE_PATH }} target="_blank" className="edu-link-a" onClick={(e) => onDropdownLinkClick(e,"Support",TEACHER_SUPPORT_PAGE_PATH)} >
          Support
        </Link>
      </EduLink>

    </MenuWrapper>
  );
});

export default EducatorMenu;
